/**
 * Event Registry Exports
 *
 * The single authored wire-contract table and everything derived from it.
 */

export {
  EVENT_REGISTRY,
  EventSchemas,
  FORWARD_EVENTS_SET,
  FORWARD_EVENTS_DERIVED,
  SCHEMALESS_EVENTS,
  type EventContract,
  type EventRegistry,
  type EventSchemaKey,
  type EventSchemasMap,
} from './registry.js';
// Payload types derived from the registry (one author per wire shape). The legacy
// EventPayloadMap alias is exported from types/index.ts, not here, so the root
// barrel's two `export *` never collide on that name.
export type {
  PayloadOf,
  RelayForwardTags,
  SchemaPayloadMap,
  SchemalessPayloadMap,
  TypedEventName,
} from './payloads.js';
